import { isNxgenVarsityDomain, isCreatorFoundationDomain } from './domainUtils';

/** Stable public assets are usable by the launcher without login or signed URLs. */
export function applyDomainAppIcons() {
  if (typeof document === 'undefined') return;
  const brand = isNxgenVarsityDomain() ? 'nxgen' : isCreatorFoundationDomain() ? 'creator' : 'prospect';
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const asset = (name) => `${base}/icons/${brand}/${name}`;
  const update = (selector, href) => {
    const link = document.querySelector(selector);
    if (link) link.href = href;
  };
  update('link[data-app-icon="favicon"]', asset('favicon-v2.ico'));
  update('link[data-app-icon="png"]', asset('icon-32-v2.png'));
  update('link[rel="apple-touch-icon"]', asset('icon-180-v2.png'));
  update('link[rel="manifest"]', `${base}/manifest-${brand}.json?v=2`);
}
